const IG_USER = 'pushateez';
export const IG_WEB = `https://www.instagram.com/${IG_USER}/`;

// Open the Instagram app on phones; fall back to the website if the app isn't installed.
export function openInstagram(e) {
  const ua = navigator.userAgent || '';
  const isAndroid = /Android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isAndroid && !isIOS) return; // desktop: normal link in a new tab
  e.preventDefault();
  if (isAndroid) {
    window.location.href = `intent://instagram.com/_u/${IG_USER}/#Intent;package=com.instagram.android;scheme=https;S.browser_fallback_url=${encodeURIComponent(IG_WEB)};end`;
    return;
  }
  const start = Date.now();
  const fallback = setTimeout(() => {
    if (!document.hidden && Date.now() - start < 2500) window.location.href = IG_WEB;
  }, 1500);
  document.addEventListener('visibilitychange', () => document.hidden && clearTimeout(fallback), { once: true });
  window.location.href = `instagram://user?username=${IG_USER}`;
}
